import styled from "styled-components";

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;

  & > * {
    margin-left: 12px;
  }
`;
